<template>
  <div class="profil-container">
    <need-review
      :title="'Need Review'"
      :modalClose="closeReview"
      :submit="needReview"
      v-if="is_catatan_open"
    />
    <need-review
      :title="'Reject'"
      :modalClose="closeReject"
      :submit="reject"
      v-if="is_reject_open"
    />
    <h3 class="profil-title">
      Terima Kasih
    </h3>
    <div class="instruction-wrapper">
      <div class="instruction-list">
        <div class="instruction-number">1.</div>
        <div class="instruction-text">
          Formulir Pra-Kualifikasi K3L ini telah diisi oleh Perusahaan yang
          mengajukan dengan sebenar-benarnya.
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">2.</div>
        <div class="instruction-text">
          Semua data yang diisikan dan/atau lampiran dokumen pendukung adalah
          benar dan akurat pada saat dokumen formulir Pra-Kualifikasi K3L ini
          diserahkan ke pihak PT Berau Coal.
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">3.</div>
        <div class="instruction-text">
          Jika data yang diisikan dan/atau lampiran dokumen pendukung yang
          diberikan tidak benar, tidak akurat dan tidak diketahui oleh Pimpinan
          Tertinggi Perusahaan maka tidak akan diperiksa dan Perusahaan tidak
          akan diundang untuk mengikuti proses selanjutnya.
        </div>
      </div>
      <div class="vendor-form mt40">
        <div
          class="input-100"
          style="display:flex; align-items:center; justify-content:center"
        >
          <input type="checkbox" value="1" v-model="done" disabled />
          <label class="ml20"
            >Dengan ini menyatakan bahwa pernyataan yang telah diisi dan dokumen
            pendukung yang dilampirkan sudah benar, akurat dan lengkap serta
            menyetujui seluruh peraturan yang tertera diatas</label
          >
        </div>
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div
        @click="approve()"
        class="btn-landing"
        v-if="!$store.state.k3lStore.is_sipm_approved"
      >
        Approve
      </div>
      <div
        @click="openReject()"
        class="btn-landing"
        v-if="!$store.state.k3lStore.is_sipm_approved"
      >
        Reject
      </div>
      <div
        @click="openReview()"
        class="btn-landing"
        v-if="!$store.state.k3lStore.is_sipm_approved"
      >
        Need Review
      </div>
      <!-- <div @click="reviewNow()" class="btn-landing">Revice Now</div> -->
      <div @click="goBack()" class="btn-landing">Kembali</div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '../../services/config'
export default {
  components: {
    NeedReview: () => import('@/components/customModal/need-review.vue'),
  },
  data() {
    return {
      selesai: 0,
      done: 1,
      is_catatan_open: false,
      is_reject_open: false,
      is_done: false,
    }
  },
  methods: {
    async approve() {
      await this.$store.commit('k3lStore/APPROVE_K3L_SIPM', {
        id: this.$route.params.id,
        note: '',
        user_id: this.$route.params.user
      })
      // try {
      //   await this.$store.commit('k3lStore/SET_K3L_FORM', {
      //     name: 'globalLoading',
      //     value: true,
      //   })
      //   const url = `${api}/api/v1/request/approve/${this.$route.params.id}`
      //   const { data } = await axios({
      //     method: 'POST',
      //     url,
      //     data: {
      //       note: '',
      //       user_id: this.$route.params.user,
      //     },
      //   })

      //   if (data) {
      //     await this.$store.commit('k3lStore/SET_K3L_FORM', {
      //       name: 'is_sipm_approved',
      //       value: true,
      //     })
      //     await this.$store.commit('k3lStore/SET_K3L_FORM', {
      //       name: 'globalLoading',
      //       value: false,
      //     })
      //     this.sendNotif(data.message)
      //   }
      // } catch (error) {
      //   console.log(
      //     '🚀 ~ file: selesai-sipm.vue ~ line 74 ~ approve ~ error',
      //     error
      //   )
      //   this.$store.commit(
      //     'SET_NOTIF',
      //     this.$get(error, 'response.data.message', 'Error')
      //   )
      //   await this.$store.commit('k3lStore/SET_K3L_FORM', {
      //     name: 'globalLoading',
      //     value: false,
      //   })
      // }
    },
    async reject(catatan) {
      try {
        await this.$store.commit('k3lStore/SET_K3L_FORM', {
          name: 'globalLoading',
          value: true,
        })
        const url = `${api}/api/v1/request/reject-k3l/${this.$route.params.id}`
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            note: catatan,
            user_id: this.$route.params.user,
          },
        })
        if (data) {
          this.is_reject_open = false
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'is_sipm_approved',
            value: true,
          })
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
          this.sendNotif(data.message)
        }
      } catch (error) {
        console.log(
          '🚀 ~ file: selesai-sipm.vue ~ line 88 ~ reject ~ error',
          error
        )
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        await this.$store.commit('k3lStore/SET_K3L_FORM', {
          name: 'globalLoading',
          value: false,
        })
      }
    },
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup78' })
    },
    goProcess() {
      this.$store.commit('k3lStore/PROCESSING_K3L')
    },
    sendNotif(value) {
      this.$store.commit('SET_NOTIF', value)
    },
    openReview() {
      this.is_catatan_open = true
    },
    closeReview() {
      this.is_catatan_open = false
    },
    openReject() {
      this.is_reject_open = true
    },
    closeReject() {
      this.is_reject_open = false
    },
    async needReview(catatan) {
      const id = this.$route.params.id
      const user_id = this.$route.params.user
      const url = `${api}/api/v1/request/reviewsipm-k3l/${id}`

      this.$store.commit('k3lStore/SET_K3L_FORM', {
        name: 'globalLoading',
        value: true,
      })
      try {
        const { data: response } = await axios({
          method: 'POST',
          url,
          data: {
            user_id,
            note: catatan,
          },
        })

        if (response && response.status == 'success') {
          this.is_catatan_open = false
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'is_sipm_approved',
            value: true,
          })
          await this.$store.commit('SET_NOTIF', response.message)
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        }
      } catch (error) {
        console.log(
          '🚀 ~ file: selesai-hoc.vue ~ line 107 ~ needReview ~ error',
          error
        )
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        this.$store.commit('k3lStore/SET_K3L_FORM', {
          name: 'globalLoading',
          value: false,
        })
      }
    },
  },
}
</script>
